export default "__VITE_ASSET__DbHQKnDf__"